// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4759) return "static/chunks/4759.c86d178ae2885095.js";
	if (chunkId === 6967) return "static/chunks/6967.df95b18388c108e3.js";
	if (chunkId === 3384) return "static/chunks/3384.9be0253e70d2300d.js";
	if (chunkId === 1822) return "static/chunks/1822.1a1417fc5400292e.js";
	if (chunkId === 7359) return "static/chunks/7359.284a8a6f35c217bc.js";
	if (chunkId === 9428) return "static/chunks/9428.6494c2dae89fad7c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1545":"d33fd29609b97fcf","1867":"b46b1830141df850","1961":"76995f3beea3f217","5723":"574216c51ab8157d","5973":"d0695a3776e6e544","8280":"2eebf22cc58abc1e","8577":"bc3c7c578f502cbd","8884":"6ed10dc7bed2b7d7","9418":"4cef63caff2399c9"}[chunkId] + ".js";
};